module.exports = __webpack_public_path__ + "img/ltc.7e49dcc6.svg";